import { useCopies } from "../../../../hooks/useCopies";
import Button from "../../../../components/button";
import React from "react";
import DefaultAssetPreview from "../defaultAssetPreview";
import { AssetUploadType, SelectedAssetType } from "../types";
import { Modal, ModalBody, ModalHeader } from "../../../../components/modal";
import AssetInputForm from "./assetInputForm";
import { DefaultFileAssetUIRendererArgsType, FileUploadModalArgsType } from "./type";
import { getAssetUploadRecommendedCopy } from "../util";
import Icon from "assets/icons";
import Size from "shared/enums/Size";

export default function DefaultFileAssetUIRenderer({
  assetUploadType = AssetUploadType.FILE,
  ...props
}: DefaultFileAssetUIRendererArgsType) {
  const copies = useCopies();
  const [isAdding, setIsAdding] = React.useState<boolean>(false);
  return (
    <div className="defaultFileAsset">
      <div className="noteBlock">
        {getAssetUploadRecommendedCopy({
          copies,
          config: props.assetConfig,
          assetUploadType,
          min: props.min,
          max: props.max,
          customCopyKey: props.recommendedCustomCopyKey
        })}
      </div>
      <div className="defaultFileAsset--wrapper">
        <Button
          className="defaultFileAsset--btn"
          icon={<Icon.FileAdd />}
          onClick={() => setIsAdding(true)}
          disabled={props.disabled || props.uploadedAssets.length === props.max}
        />
        {props.uploadedAssets.map(asset => (
          <DefaultAssetPreview
            key={asset.id}
            asset={asset}
            assetUploadType={assetUploadType}
            disabled={props.disabled}
            removeHandler={props.removeAsset}
            disableImagePreview={props.disableImagePreview}
          />
        ))}
      </div>
      {isAdding && <FileUploadModal {...props} assetUploadType={assetUploadType} onClose={() => setIsAdding(false)} />}
    </div>
  );
}

function FileUploadModal({ uploadSelectedAsset, onClose, ...props }: FileUploadModalArgsType) {
  const copies = useCopies();
  const uploadSuccessHandler = React.useCallback(
    async (asset: SelectedAssetType) => {
      try {
        await uploadSelectedAsset?.(asset);
        onClose();
      } catch (e) {}
    },
    [uploadSelectedAsset, onClose]
  );

  return (
    <Modal size={Size.SMALL} className="uploadFileModal">
      <ModalHeader left={copies.get("upload.file")} onClose={onClose} />
      <ModalBody>
        <AssetInputForm
          assetConfig={props.assetConfig}
          uploadSelectedAsset={uploadSuccessHandler}
          disabled={props.disabled}
          assetUploadType={props.assetUploadType}
        />
      </ModalBody>
    </Modal>
  );
}
